import React from 'react';
import { useTranslation } from 'react-i18next';

export const Message: React.FC = () => {
  const { t } = useTranslation();
  return (
    <p className="message">
      {t('text.password.reset.index.request')}
      <br />
      {t('text.password.reset.index.attention')}
    </p>
  );
};
